import React, { useEffect, useState } from "react";
import Modal, { ModalController } from "Components/Modal/Modal";
import ModalTitle from "./ModalTitle";
import { Button, DialogContent } from "@material-ui/core";

function TinyModal<T>(props: {
	title: string;
	modalController: ModalController<T>;
	action: (item?: T) => Promise<void>;
	actionLabel: string;
	children?: React.ReactNode;
}) {
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (props.modalController.isOpen) {
			setIsSubmitting(false);
		}
	}, [props.modalController.isOpen]);

	if (props.modalController.isOpen) {
		return (
			<Modal
				size="xs"
				modalController={props.modalController}
			>
				<ModalTitle close={props.modalController.close} title={props.title}>
					<Button
						disabled={isSubmitting}
						variant="contained"
						color="primary"
						onClick={async () => {
							setIsSubmitting(true);
							try {
								await props.action(props.modalController.item);
							} catch (error) {
								setIsSubmitting(false);
							}
						}}
					>
						{props.actionLabel}
					</Button>
				</ModalTitle>
				<DialogContent>{props.children}</DialogContent>
			</Modal>
		);
	} else {
		return null;
	}
}

export default TinyModal;
